export default __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-mini-sm-5eec382f70372f3253ac8cdc69585bf4.png";